/**
 * Re-renders once a minute, so "opens in 2 h 15 min" and "next in…" on the
 * header's tiles stay true while the page is open (19/10/2026).
 * For Media Devoted | Created By Ciro Autiero
 */
import { useEffect, useState } from 'react';

export function useMinuteTick(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, []);
  return now;
}
